module.exports = __webpack_public_path__ + "img/mask-up.7d748ec3.png";